
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/feature/Footer';

const industries = [
  {
    id: 'hvac',
    name: 'HVAC Contractors',
    subtitle: 'Climate Control Experts',
    icon: 'ri-temp-cold-line',
    path: '/hvac',
    gradient: 'from-orange-500 to-red-600',
    image: 'https://public.readdy.ai/ai/img_res/bfada296f87b0fd3dcb0ac539816fd52.jpg',
    active: true
  },
  {
    id: 'plumbing',
    name: 'Plumbing Services',
    subtitle: 'Flow Management Specialists',
    icon: 'ri-drop-line',
    path: '/plumbing',
    gradient: 'from-blue-500 to-cyan-600',
    image: 'https://readdy.ai/api/search-image?query=Professional-plumber-working-under-sink-with-pipe-wrench-and-plumbing-tools-modern-bathroom-renovation-skilled-tradesman-fixing-pipes-clean-professional-workspace-high-quality-commercial-photography-detailed-technical-plumbing-work-residential-service&width=600&height=450&seq=industry-plumbing-001&orientation=landscape',
    active: false
  },
  {
    id: 'electrical',
    name: 'Electrical Contractors',
    subtitle: 'Power System Professionals',
    icon: 'ri-flashlight-line',
    path: '/electrical',
    gradient: 'from-yellow-500 to-amber-600',
    image: 'https://readdy.ai/api/search-image?query=Professional-electrician-working-on-electrical-panel-with-multimeter-and-tools-modern-residential-electrical-system-skilled-tradesman-wiring-installation-clean-professional-workspace-high-quality-commercial-photography-detailed-technical-electrical-work-safety-equipment&width=600&height=450&seq=industry-electrical-001&orientation=landscape',
    active: false
  },
  {
    id: 'mechanical',
    name: 'Mechanical Services',
    subtitle: 'Equipment Maintenance Pros',
    icon: 'ri-settings-3-line',
    path: '/mechanical',
    gradient: 'from-purple-500 to-indigo-600',
    image: 'https://readdy.ai/api/search-image?query=Professional-mechanic-working-on-industrial-machinery-with-tools-and-equipment-modern-workshop-skilled-tradesman-performing-maintenance-clean-professional-workspace-high-quality-commercial-photography-detailed-technical-mechanical-work-precision-engineering&width=600&height=450&seq=industry-mechanical-001&orientation=landscape',
    active: false
  },
  {
    id: 'general',
    name: 'General Contractors',
    subtitle: 'Build & Renovation Experts',
    icon: 'ri-building-2-line',
    path: '/general',
    gradient: 'from-slate-500 to-gray-700',
    image: 'https://readdy.ai/api/search-image?query=Professional-general-contractor-reviewing-blueprints-at-construction-site-with-hard-hat-and-tools-modern-residential-building-project-skilled-tradesman-supervising-work-clean-professional-workspace-high-quality-commercial-photography-detailed-construction-management&width=600&height=450&seq=industry-general-001&orientation=landscape',
    active: false
  },
  {
    id: 'coming',
    name: 'More Industries',
    subtitle: 'Coming Soon',
    icon: 'ri-add-line',
    path: '#',
    gradient: 'from-gray-300 to-gray-400',
    image: '',
    active: false,
    comingSoon: true
  }
];

const stats = [
  { value: '25+', label: 'Years Combined Experience' },
  { value: '40+', label: 'Businesses Transformed' },
  { value: '98%', label: 'Client Satisfaction' }
];

export default function LandingPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center shadow-lg transition-colors ${
                isScrolled ? 'bg-[#0F3A2E]' : 'bg-white'
              }`}>
                <span className={`font-bold text-xl transition-colors ${
                  isScrolled ? 'text-white' : 'text-[#0F3A2E]'
                }`}>PP</span>
              </div>
              <div className="flex flex-col">
                <span className={`text-xl font-bold leading-tight transition-colors ${
                  isScrolled ? 'text-[#0F3A2E]' : 'text-white'
                }`}>Providence Path</span>
                <span className={`text-xs font-medium transition-colors ${
                  isScrolled ? 'text-gray-600' : 'text-white/80'
                }`}>Faith-Driven Growth</span>
              </div>
            </a>

            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#industries"
                className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-[#0F3A2E]' : 'text-white hover:text-[#C9A24D]'
                }`}
              >
                Industries
              </a>
              <a
                href="#about"
                className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-[#0F3A2E]' : 'text-white hover:text-[#C9A24D]'
                }`}
              >
                About Us
              </a>
              <Link
                to="/hvac"
                className="px-6 py-3 bg-[#C9A24D] text-[#0F3A2E] font-bold rounded-full hover:bg-[#B8963E] transition-all whitespace-nowrap cursor-pointer shadow-lg"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <main className="min-h-screen bg-white">
        {/* Hero Section */}
        <header className="relative min-h-screen flex items-center justify-center overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://readdy.ai/api/search-image?query=Diverse-group-of-skilled-tradesmen-and-contractors-working-together-HVAC-technician-plumber-electrician-and-general-contractor-professional-team-collaboration-modern-commercial-building-project-high-quality-photography-warm-natural-lighting-skilled-workers-with-tools-and-equipment-teamwork-and-expertise-clean-professional-workspace-multiple-trades-working-harmoniously&width=1920&height=1080&seq=landing-hero-001&orientation=landscape)'
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0F3A2E]/80 via-[#0F3A2E]/70 to-[#0F3A2E]/80"></div>
          
          <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center w-full">
            <p className="text-[#C9A24D] text-sm font-bold tracking-widest uppercase mb-6">
              Empowering Service Businesses
            </p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Grow Your Trade Business<br />
              <span className="text-[#C9A24D]">With Faith-Driven Strategy</span>
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
              Industry-specific solutions designed for contractors who demand results. HVAC, Plumbing, Electrical, and more.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="#industries"
                className="px-8 py-4 bg-[#C9A24D] text-[#0F3A2E] text-base font-bold rounded-full hover:bg-[#B8963E] transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
              >
                Explore Your Industry
              </a>
              <a
                href="#about"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer border border-white/30"
              >
                Learn More
              </a>
            </div>
          </div>

          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
            <a href="#industries" className="text-white/80 hover:text-white transition-colors cursor-pointer">
              <i className="ri-arrow-down-line text-3xl"></i>
            </a>
          </div>
        </header>

        {/* Industry Selection Section */}
        <section id="industries" className="py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <p className="text-[#0F3A2E] text-sm font-bold tracking-widest uppercase mb-4">
                Choose Your Industry
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                Solutions Built for <strong className="text-[#0F3A2E]">Your Trade</strong>
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Select your industry to discover customized strategies, pricing, and resources designed specifically for your business
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {industries.map((industry) => (
                <div key={industry.id} className="group">
                  {industry.comingSoon ? (
                    <div className="relative h-80 rounded-2xl border-2 border-dashed border-gray-300 bg-gray-100 flex flex-col items-center justify-center cursor-default">
                      <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mb-4">
                        <i className={`${industry.icon} text-3xl text-gray-400`}></i>
                      </div>
                      <h3 className="text-xl font-bold text-gray-400 mb-2">{industry.name}</h3>
                      <p className="text-sm text-gray-400">{industry.subtitle}</p>
                    </div>
                  ) : industry.active ? (
                    <Link
                      to={industry.path}
                      className="relative h-80 rounded-2xl overflow-hidden block shadow-lg hover:shadow-2xl transition-all duration-300 group-hover:scale-[1.02]"
                    >
                      <img
                        src={industry.image}
                        alt={industry.name}
                        className="absolute inset-0 w-full h-full object-cover"
                        loading="lazy"
                        decoding="async"
                      />
                      <div className={`absolute inset-0 bg-gradient-to-t ${industry.gradient} opacity-80 group-hover:opacity-90 transition-opacity`}></div>
                      <div className="absolute inset-0 p-8 flex flex-col justify-between">
                        <div className="w-16 h-16 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:rotate-6 transition-transform">
                          <i className={`${industry.icon} text-3xl text-white`}></i>
                        </div>
                        <div>
                          <div className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-semibold text-white mb-3">
                            AVAILABLE NOW
                          </div>
                          <h3 className="text-2xl font-bold text-white mb-2">{industry.name}</h3>
                          <p className="text-white/80 text-sm mb-4 opacity-0 group-hover:opacity-100 transition-opacity">
                            {industry.subtitle}
                          </p>
                          <div className="flex items-center text-white font-semibold">
                            <span>Explore Solutions</span>
                            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ) : (
                    <div className="relative h-80 rounded-2xl overflow-hidden shadow-lg cursor-not-allowed opacity-70">
                      <img
                        src={industry.image}
                        alt={industry.name}
                        className="absolute inset-0 w-full h-full object-cover grayscale"
                        loading="lazy"
                        decoding="async"
                      />
                      <div className={`absolute inset-0 bg-gradient-to-t from-gray-700 to-gray-500 opacity-80`}></div>
                      <div className="absolute inset-0 p-8 flex flex-col justify-between">
                        <div className="w-16 h-16 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                          <i className={`${industry.icon} text-3xl text-white`}></i>
                        </div>
                        <div>
                          <div className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-semibold text-white mb-3">
                            COMING SOON
                          </div>
                          <h3 className="text-2xl font-bold text-white mb-2">{industry.name}</h3>
                          <p className="text-white/80 text-sm">{industry.subtitle}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-[#0F3A2E]">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-3 gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-5xl md:text-6xl font-bold text-[#C9A24D] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {stat.value}
                  </div>
                  <div className="text-white/80 text-lg">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="about" className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="relative">
                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src="https://static.readdy.ai/image/8a088853fb554840745d180bcc58d87d/751fe7cc5fe7b284952641919d28d4a8.jpeg"
                    alt="Trey and Nichole Wright - Providence Path Founders"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8 lg:p-10 shadow-lg">
                <p className="text-[#0F3A2E] text-sm font-bold tracking-widest uppercase mb-4">
                  About Providence Path
                </p>
                <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Faith-Driven Growth for <strong className="text-[#0F3A2E]">Every Trade</strong>
                </h2>
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  We understand the unique challenges service businesses face because we've been there. After years of building and scaling ventures across multiple industries, we discovered that success isn't just about tactics—it's about building on a foundation of purpose, integrity, and service.
                </p>
                <p className="text-base text-gray-700 leading-relaxed mb-8">
                  Providence Path was born from our desire to help trade professionals create sustainable growth while staying true to their values. Whether you're in HVAC, plumbing, electrical, or any skilled trade, we have the expertise to help you succeed.
                </p>
                <Link
                  to="/hvac"
                  className="inline-flex items-center px-6 py-3 bg-[#0F3A2E] text-white font-bold rounded-full hover:bg-[#0A2A20] transition-all cursor-pointer shadow-lg"
                >
                  <span>Start Your Journey</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                Why <strong className="text-[#0F3A2E]">Providence Path</strong>?
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                We bring industry-specific expertise combined with faith-driven values to help your business thrive
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-[#0F3A2E]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-focus-3-line text-3xl text-[#0F3A2E]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Industry-Specific</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Tailored strategies for each trade. We understand the unique challenges and opportunities in HVAC, plumbing, electrical, and more.
                </p>
              </div>

              <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-[#0F3A2E]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-heart-line text-3xl text-[#0F3A2E]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Faith-Centered</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  We integrate Christian principles into every aspect of business growth, helping you build with purpose and integrity.
                </p>
              </div>

              <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-[#0F3A2E]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-line-chart-line text-3xl text-[#0F3A2E]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Proven Results</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Our strategies are battle-tested across multiple industries, delivering sustainable growth for businesses of all sizes.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-[#0F3A2E] relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-96 h-96 bg-[#C9A24D] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#C9A24D] rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
          </div>
          <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Ready to Transform Your Business?
            </h2>
            <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto">
              Join the growing community of trade professionals who are building successful businesses with faith-driven strategies.
            </p>
            <Link
              to="/hvac"
              className="inline-flex items-center px-8 py-4 bg-[#C9A24D] text-[#0F3A2E] text-lg font-bold rounded-full hover:bg-[#B8963E] transition-all hover:scale-105 cursor-pointer shadow-lg"
            >
              <span>Get Started Today</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
